// extracted by mini-css-extract-plugin
export var callCard = "_ks-0";
export var callMessageButton = "_ks-1";
export var helpIcon = "_ks-3";
export var helpIconContainer = "_ks-4";
export var verticalDivider = "_ks-2";